'use client'

import { useNavigate } from "react-router";
//import MicrosoftLogin from "../../Components/MicrosoftLogin";
import { useMsal } from "@azure/msal-react";
import { useDispatch } from "react-redux";
import { SetEntornoEmp } from "../../redux/store/Actions";
import axios from "axios";
import { isEmail } from "../../lib";
import LoaderSpinner from "../../Components/LoaderSpinner";
import { useState } from "react";
import Swal from "sweetalert2";

const  LoginPage = () => {

  let navigate = useNavigate();
  const { instance } = useMsal();
  const dispatch = useDispatch();
  let [user, setUser] = useState("");
  let [emErr, setEmrr] = useState(false);
  let [loading, setLoading] = useState(false);  

  const LocalLogin = async () =>{

    if (isEmail(user.trim())){

      setLoading(true);    
      const urlApiBase = process.env.REACT_APP_apiUrl;
      const apikey = process.env.REACT_APP_Coosalud_Api_Key;

      const headers = {
        headers: {
          'Coosalud-Api-Key': `${apikey}`,
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      };
      const body = {
        'Token': `${user}`,  
        'UserName': `${user}`,   
      };

      axios.post(`${urlApiBase}/api/Auth/Internal/ValidateUser`,  body, headers)
      .then((resp: any)=>{
        dispatch(SetEntornoEmp({
            first_name: "Usuario ", id_user: "0",
            last_name: "pruebas", profile: "a.b.c.d.e", 
            token:  `${resp.data.Token}`, user:user
        }));
        navigate('/home');   
      })
      .catch((error: any) => {
        Swal.fire({
          title: '¡Advertencia!',
          text: `El correo ${user.trim()} no está autorizado para ingresar.`,
          icon: "error",
          iconColor: "red",
          confirmButtonText: 'Aceptar',
          confirmButtonColor: 'red',
        });
      });        

      setLoading(false);         

    }else{
        setEmrr(true)
    }
  }

  const handleLogin = async () => {
    const res = await instance.loginPopup().catch(e => {
        console.log("Error: ", e);
    });
  };

    return (
      <div className="row m-3">
        <div className="col-lg-6 col-md-12 text-center">
          <div className="">
            <img className="img-fluid border-0 rounded" alt="Bienvenido a Coosalud" src="https://portalempleador.coosalud.com/assets/images/fondo-portal2.jpg" 
                  style={{  width: '100vw',   height: '100vh',   objectFit: 'cover',  objectPosition: 'center',   margin: 'auto', display: 'block'}} 
            />
          </div>          
        </div>

        <div className="col-lg-6 col-md-12 d-flex align-items-center justify-content-center">
          <div>
            <div className="d-flex justify-content-center m-3">
              <img  className="img-fluid" alt="Bienvenido a Coosalud"  src="https://coosalud-dev.outsystemsenterprise.com/Login/img/Login_CW.logo_coosalud.png?cj4Zp4YmT0_Mybz+AyalDg"/>
            </div>
            <div className="d-flex justify-content-center text-success text-center m-3">
              <span className="h4 fw-bold">PORTAL EMPLEADOR ADMINISTRACIÓN</span>
            </div>
            <div className="row d-flex justify-content-center m-3 gap-2">
              <div className="col-lg-12">
                <input type="text" className="form-control" value={user} onChange={(evnt: any)=>{
                  setUser(evnt.target.value);
                  setEmrr(false);
                }}/>  
                {emErr && <span className="text-danger">Email no es válido</span>}                                
              </div>
              <div className="col-lg-12 text-center">
                  <button className="btn btn-success w-50" onClick={LocalLogin}>Ingresar</button>                
              </div>
              {/*<MicrosoftLogin onclick={Login} />*/}              
            </div>

          </div>          
        </div>
        <LoaderSpinner
          color="#0fc26f"
          Show={loading}
          text="Procesando..."
        />
      </div>
    );
};

export default LoginPage;
  